import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

const CustomTab = (props) => {
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    if (props.tab.length > 0 && activeTab !== '') {
      const selectedTabFilters = props.tab[activeTab].filters;
      props.loadData(selectedTabFilters);
    }
  }, [activeTab]); // Executar quando activeTab muda

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <Nav tabs>
        {props.tab.map((tab, index) => (
          <NavItem key={index}>
            <NavLink
              style={{ cursor: 'pointer', position: 'relative', marginRight: '10px' }}
              className={classnames({ active: activeTab === index })}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </div>
  );
}

export default CustomTab;
